"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaboratorFilterControl = void 0;
var collaborator_filter_control_component_1 = require("./collaborator-filter-control.component");
Object.defineProperty(exports, "CollaboratorFilterControl", { enumerable: true, get: function () { return collaborator_filter_control_component_1.CollaboratorFilterControl; } });
